import { Query } from '../query/Query';
import { replacePlaceholders } from '../utils/replacePlaceholders';
import { isNullOrEmpty } from '../utils/typeChecks';
import { IApplySubQueryPlaceholders } from '../models/utils/IApplySubQueryPlaceholders';

export function applySubQueryPlaceholders(params: IApplySubQueryPlaceholders) {
	let { template } = params;
	const { executionOptions, subQueries, allSubQueryValuesRequired } = params;
	if (subQueries) {
		// If there are subqueries, translate the template before replacing the placeholders
		if (executionOptions && executionOptions.translate) {
			template = executionOptions.translate(template);
		}
		const subQueryValues: { [key: string]: any } = {};
		let hasBlankValue = false;
		for (let subQueryIndex = 0; subQueryIndex < subQueries.length; subQueryIndex++) {
			const subQueryOptions = subQueries[subQueryIndex];
			const { queryId = `subQuery${subQueryIndex}` } = subQueryOptions;
			const subQuery = new Query(subQueryOptions, this.translationHelper);
			const subQueryValue = subQuery.execute(executionOptions);
			const key = `sub:${queryId}`;
			if (allSubQueryValuesRequired && isNullOrEmpty(subQueryValue)) {
				hasBlankValue = true;
				break;
			}
			subQueryValues[key] = subQueryValue;
		}
		if (allSubQueryValuesRequired && hasBlankValue) {
			template = undefined;
		}
		else {
			template = replacePlaceholders(subQueryValues, template);
		}
	}
	return template;
}